/**
 * Session lifecycle management module
 */

import { sessionState } from './state';
import { sendEventBatch } from './batch';

/**
 * End session and cleanup
 */
export function endSession(reason: string): void {
  if (sessionState.sessionEnded) {
    return;
  }

  // Clear intervals
  if (sessionState.sendIntervalId) {
    clearInterval(sessionState.sendIntervalId);
    sessionState.sendIntervalId = null;
  }
  if (sessionState.idleCheckIntervalId) {
    clearInterval(sessionState.idleCheckIntervalId);
    sessionState.idleCheckIntervalId = null;
  }

  // Stop recording
  if (sessionState.stopRecording) {
    sessionState.stopRecording();
    sessionState.stopRecording = null;
  }

  // Mark session as ended
  sessionState.sessionEnded = true;

  // Send final batch
  sendEventBatch(true, reason);
}
